export default {"src":"/_next/static/media/61973d430b843bda877fa473_hero-circles-right.15351a08.svg","height":607,"width":382};